import apiClients from "../api/axiosConfig";

export const getRule = async (feeId, rule) =>
    apiClients.feesAPI.get(`/api/v1/feeRules/${feeId}?feeRule=${rule}`);

export const updateRule = async (request) =>
    apiClients.feesAPI.put(`/api/v1/feeRules`, request);